import { trackMove } from '@otto-ec/nexus-registry/pdp/tracking';

export const addMoveTrackingToLink = (linkElement: HTMLElement) => {
    const moveActionTrackingLabelValue = linkElement.dataset.moveActionTrackingLabelValue;
    if (moveActionTrackingLabelValue) {
        linkElement.addEventListener('click', () => {
            trackMove({ ot_PageCluster: ['Artikeldetailseite'], review_Navigation: [moveActionTrackingLabelValue] });
        });
    }
};
